var reviewCard = {
  review: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Lorem ipsum dolor sit amet,magna.","nodeType":"text"}],"nodeType":"paragraph"},{"data":{},"content":[{"data":{},"marks":[],"value":"Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}',
  reviewLinkUrl: 'https://www.yelpblog.com/',
  reviewLinkText: 'Read more on Yelp',
  reviewerImageUrl: 'https://images.ctfassets.net/rt5zmd3ipxai/1sgRxgvSNqYx7YDp20KUcQ/ca719209ee9c0badd8bcd0f603b84575/new-_cropped_-_staff_-_new_staff_member_pete.jpg?fit=fill&fm=webp&h=75&w=75&q=80',
  // reviewerImageUrl: './images/dummies/75.png',
  reviewerImageAlt: 'Kaya Pryor',
  reviewerName: 'Kaya Pryor'
};
export { reviewCard };